import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Autumn/FractionsB/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'FractionsB',
  field: 'Number',
  weeks: [10, 11],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsB/1MultiplyFractionsByIntegers" */ './1MultiplyFractionsByIntegers'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsB/2MultiplyFractionsByFractions" */ './2MultiplyFractionsByFractions'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsB/3DivideAFractionByAnInteger" */ './3DivideAFractionByAnInteger'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsB/4DivideAnyFractionByAnInteger" */ './4DivideAnyFractionByAnInteger'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsB/5MixedQuestionsWithFractions" */ './5MixedQuestionsWithFractions'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsB/6FractionOfAnAmount" */ './6FractionOfAnAmount'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Autumn/FractionsB/7FractionOfAnAmountFindTheWhole" */ './7FractionOfAnAmountFindTheWhole'
        )
    })
  ]
});
export default Block;
